/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import {
	breedList,
	colorList,
	genderList,
	skillsList,
	heightList,
	temperamentList,
	conditionList,
	yearList,
	saleTypeList,
	tackCategoryList,
	adTypeList,
	leaseTypeList,
} from '../util/data';
import { BehaviorSubject, Observable } from 'rxjs';
import { getStepSize } from '../util/price-range-utils';

@Injectable({
	providedIn: 'root',
})
export class FilterService {
	public breedList = breedList;
	public colorList = colorList;
	public genderList = genderList;
	public skillsList = skillsList;
	public heightList = heightList;
	public yearList = yearList;
	public tackCategories = tackCategoryList;
	public conditionList = conditionList;
	public temperamentList = temperamentList;
	public saleTypeList = saleTypeList;
	public adTypeList = adTypeList;
	public leaseTypeList = leaseTypeList;
	private askingPriceThresholds = [
		{ upperLimit: 10000, step: 100 },
		{ upperLimit: 30000, step: 500 },
		{ upperLimit: 75000, step: 1000 },
		{ upperLimit: 200000, step: 5000 },
		{ upperLimit: 500000, step: 10000 },
	];

	public topCatList: any[] = [
		{
			pk: 'horses',
			name: 'Horses',
		},
		{
			pk: 'tack',
			name: 'Tack',
		},
	];
	private displayBar = [
		{
			key: 'keyword',
			label: 'Keyword',
			type: 'text',
			isSet: false,
			model: '',
			start_value: '',
			source: 'displayBar',
			al_key: 'keyword',
		},
		{
			key: 'adTypes',
			label: 'Ad Types',
			type: 'select-searchable',
			canSearch: false,
			canClear: true,
			isMultiple: true,
			itemList: this.adTypeList,
			model: [],
			start_value: [],
			isSet: false,
			quickFilter: true,
			source: 'displayBar',
			al_key: 'ad_type',
		},
		{
			key: 'saleTypes',
			label: 'Sale Types',
			type: 'select-searchable',
			canSearch: false,
			canClear: true,
			isMultiple: true,
			itemList: this.saleTypeList,
			model: [],
			start_value: [],
			isSet: false,
			quickFilter: true,
			source: 'displayBar',
			al_key: 'sale_type',
		},
		{
			key: 'leaseTypes',
			label: 'Lease Types',
			type: 'select-searchable',
			canSearch: false,
			canClear: true,
			isMultiple: true,
			itemList: this.leaseTypeList,
			model: [],
			start_value: [],
			isSet: false,
			quickFilter: true,
			source: 'displayBar',
			al_key: 'lease_type',
		},
		{
			key: 'location',
			label: 'Location',
			type: 'button',
			isSet: false,
			quickFilter: true,
			model: {
				address: '',
				address_2: '',
				city: '',
				state: '',
				country: '',
				postal: '',
				lat: '',
				long: '',
				range: 0,
				placeName: '',
			},
			start_value: {
				address: '',
				address_2: '',
				city: '',
				state: '',
				country: '',
				postal: '',
				lat: '',
				long: '',
				range: 0,
				placeName: '',
			},
			useCurrentLocation: false,
			source: 'displayBar',
			al_key: 'location',
		},
		{
			key: 'topCat',
			label: 'Category',
			type: 'select-searchable:custom',
			isMultiple: false,
			canSearch: false,
			canClear: false,
			itemList: this.topCatList,
			model: this.topCatList[0],
			start_value: this.topCatList[0],
			isSet: false,
			quickFilter: false,
			source: 'displayBar',
			al_key: '',
		},
		{
			key: 'askingPrice',
			label: 'Asking Price',
			min: 0,
			max: 50000,
			model: { lower: 0, upper: 50000 },
			start_value: { lower: 0, upper: 50000 },
			type: 'range',
			isSet: false,
			quickFilter: true,
			source: 'displayBar',
			step: (lower: number) => getStepSize(lower),
			isMax: true,
			isMin: true,
			dep: this.saleTypeList[0],
			depKey: 'saleTypes',
			depMet: true,
			al_key: 'asking_price',
		},
		{
			key: 'leasePrice',
			label: 'Lease Price',
			min: 0,
			max: 3000,
			model: { lower: 0, upper: 3000 },
			start_value: { lower: 0, upper: 3000 },
			type: 'range',
			isSet: false,
			quickFilter: true,
			source: 'displayBar',
			step: 50,
			isMax: true,
			isMin: true,
			dep: this.saleTypeList[1],
			depKey: 'saleTypes',
			depMet: true,
			al_key: 'lease_price',
		},
		{
			key: 'tradeFor',
			label: 'Trade For',
			type: 'text',
			model: '',
			start_value: '',
			isSet: false,
			quickFilter: false,
			source: 'displayBar',
			dep: this.saleTypeList[2],
			depKey: 'saleTypes',
			depMet: true,
			al_key: 'seeking',
		},

		{
			key: 'skills',
			label: 'Skills',
			type: 'select-searchable',
			canSearch: true,
			canClear: true,
			isMultiple: true,
			itemList: this.skillsList,
			model: [],
			start_value: [],
			isSet: false,
			quickFilter: true,
			source: 'displayBar',
			al_key: 'skills',
		},
	];
	private displayBarTack = [
		{
			key: 'category',
			label: 'Category',
			type: 'select-searchable',
			isMultiple: false,
			canClear: true,
			canSearch: true,
			itemList: this.tackCategories,
			model: [],
			start_value: [],
			isSet: false,
			source: 'displayBarTack',
			al_key: 'categories',
		},
		{
			key: 'brand',
			label: 'Brand',
			type: 'text',
			model: '',
			start_value: '',
			isSet: false,
			source: 'displayBarTack',
			al_key: 'brand',
		},
		{
			key: 'model',
			label: 'Model',
			type: 'text',
			model: '',
			start_value: '',
			isSet: false,
			source: 'displayBarTack',
			al_key: 'model',
		},
		{
			key: 'condition',
			label: 'Condition',
			type: 'select-searchable',
			isMultiple: true,
			canClear: true,
			canSearch: false,
			itemList: this.conditionList,
			model: [],
			start_value: [],
			isSet: false,
			source: 'displayBarTack',
			al_key: 'condition',
		},
	];
	private displayBarHorses = [
		{
			key: 'breed',
			label: 'Breed',
			type: 'select-searchable',
			isMultiple: true,
			canClear: true,
			canSearch: true,
			itemList: this.breedList,
			model: [],
			start_value: [],
			isSet: false,
			quickFilter: true,
			source: 'displayBarHorses',
			al_key: 'breed',
		},
		{
			key: 'color',
			label: 'Color',
			type: 'select-searchable',
			isMultiple: true,
			canClear: true,
			canSearch: true,
			itemList: this.colorList,
			model: [],
			start_value: [],
			isSet: false,
			quickFilter: true,
			source: 'displayBarHorses',
			al_key: 'color',
		},
		{
			key: 'gender',
			label: 'Gender',
			type: 'select-searchable',
			isMultiple: true,
			canClear: true,
			canSearch: false,
			itemList: this.genderList,
			model: [],
			start_value: [],
			isSet: false,
			quickFilter: true,
			source: 'displayBarHorses',
			al_key: 'gender',
		},
		{
			key: 'height',
			label: 'Height',
			min: 0,
			max: this.heightList.length - 1,
			itemList: this.heightList,
			model: { lower: 0, upper: this.heightList.length - 1 },
			start_value: { lower: 0, upper: this.heightList.length - 1 },
			type: 'range',
			isSet: false,
			quickFilter: true,
			source: 'displayBarHorses',
			step: 1,
			isMax: true,
			isMin: true,
			al_key: 'height',
		},
		{
			key: 'temperament',
			label: 'Temperament',
			type: 'range',
			step: () => 1,
			isSet: false,
			quickFilter: true,
			source: 'displayBarHorses',
			itemList: this.temperamentList,
			model: { lower: 0, upper: this.temperamentList.length - 1 },
			start_value: { lower: 0, upper: this.temperamentList.length - 1 },
			al_key: 'temperament',
		},
		{
			key: 'yearFoaled',
			label: 'Year Foaled',
			type: 'range',
			min: 0,
			max: this.yearList.length - 1,
			isSet: false,
			quickFilter: true,
			source: 'displayBarHorses',
			itemList: this.yearList,
			model: { lower: 0, upper: this.yearList.length - 1 },
			start_value: { lower: 0, upper: this.yearList.length - 1 },
			al_key: 'year_foaled',
		},
	];
	private filterSubject: BehaviorSubject<any> = new BehaviorSubject(this.getFilterBar());

	constructor() {
		this.initializeFilters();
	}

	private initializeFilters() {
		// Initialize displayBar filters
		this.displayBar.forEach((filter) => {
			if (filter.start_value !== undefined) {
				filter.model = this.cloneFilterValue(filter.start_value);
			}
		});

		// Initialize displayBarHorses filters
		this.displayBarHorses.forEach((filter) => {
			if (filter.start_value !== undefined) {
				filter.model = this.cloneFilterValue(filter.start_value);
			}
		});

		// Initialize displayBarTack filters
		this.displayBarTack.forEach((filter) => {
			if (filter.start_value !== undefined) {
				filter.model = this.cloneFilterValue(filter.start_value);
			}
		});
	}

	private cloneFilterValue(value: any): any {
		if (Array.isArray(value)) {
			return [...value];
		} else if (value !== null && typeof value === 'object') {
			return JSON.parse(JSON.stringify(value));
		} else {
			return value;
		}
	}

	calculateStep(lower: number, max: number, thresholds: { upperLimit: number; step: number }[]): number {
		for (let i = thresholds.length - 1; i >= 0; i--) {
			if (lower <= thresholds[i].upperLimit) {
				return thresholds[i].step;
			}
		}
		// Default step if no threshold matches
		return thresholds[0].step;
	}

	public resetAllFilters() {
		this.displayBar.forEach((filter) => {
			filter.model = this.cloneFilterValue(filter.start_value);
			filter.isSet = false;
		});
		this.displayBarHorses.forEach((filter) => {
			filter.model = this.cloneFilterValue(filter.start_value);
			filter.isSet = false;
		});
		this.displayBarTack.forEach((filter) => {
			filter.model = this.cloneFilterValue(filter.start_value);
			filter.isSet = false;
		});
		this.notifySubscribers();
	}

	public getFilterBar() {
		const filterBar = [...this.displayBar, ...this.displayBarHorses];
		return filterBar;
	}
	getDynamicStepFunction(max: number, thresholds: { upperLimit: number; step: number }[]) {
		return (lower: number, upper: number): number => {
			console.log('Dynamic step calculation:');
			console.log(`Lower: ${lower}, Upper: ${upper}`);
			const step = this.calculateStep(lower, max, thresholds);
			console.log(`Calculated Step: ${step}`);
			return step;
		};
	}
	getFilterBarStream(): Observable<any[]> {
		return this.filterSubject.asObservable();
	}

	setFilter(key: string, newValue: any) {
		this.updateFilterBar(key, (filter) => {
			filter.model = JSON.parse(JSON.stringify(newValue)); // Ensure deep clone
			const isSet = this.determineFilterIsSet(filter, newValue);
			console.log('filter bar is doing update:');
			console.log('newValue:', newValue);
			console.log('start_value:', filter.start_value);
			console.log(`${filter.key}: isSet = ${isSet}`);
			filter.isSet = isSet;
		});
		this.notifySubscribers();
	}

	private determineFilterIsSet(filter: any, newValue: any): boolean {
		// Handle multiselect arrays
		if (Array.isArray(newValue)) {
			// Empty array = not set
			if (newValue.length === 0) {
				return false;
			}
			// Has selections = set (regardless of whether it matches start_value)
			return true;
		}

		// Handle range objects
		if (newValue && typeof newValue === 'object' && newValue.lower !== undefined && newValue.upper !== undefined) {
			// Compare range against start_value
			return this.checkIfValueIsDifferent(newValue, filter.start_value);
		}

		// Handle single values and other types
		if (newValue === null || newValue === undefined || newValue === '') {
			return false;
		}

		// Compare against start_value for other types
		return this.checkIfValueIsDifferent(newValue, filter.start_value);
	}

	private updateFilterBar(key: string, updater: (filter: any) => void) {
		const update = (filterBar: any[]) => {
			const filter = filterBar.find((f) => f.key === key);
			if (filter) {
				updater(filter);
			}
		};
		update(this.displayBar);
		update(this.displayBarHorses);
	}

	resetFilter(key: string) {
		this.updateFilterBar(key, (filter) => {
			filter.model = JSON.parse(JSON.stringify(filter.start_value));
			filter.isSet = false;
		});
		this.notifySubscribers();
	}

	private notifySubscribers() {
		this.filterSubject.next(this.getFilterBar());
	}

	private checkIfValueIsDifferent(currentValue: any, startValue: any): boolean {
		console.log('Checking if values are different:', { currentValue, startValue });

		if (typeof currentValue !== typeof startValue) {
			console.log('Different types:', { currentType: typeof currentValue, startType: typeof startValue });
			return true;
		}

		// Deep comparison for arrays
		if (Array.isArray(currentValue) && Array.isArray(startValue)) {
			if (currentValue.length !== startValue.length) {
				console.log('Arrays have different lengths:', { currentLength: currentValue.length, startLength: startValue.length });
				return true;
			}
			const arraysEqual = currentValue.every((val, index) => val === startValue[index]);
			if (!arraysEqual) {
				console.log('Arrays have different values:', { currentValue, startValue });
			}
			return !arraysEqual;
		}

		// Deep comparison for objects
		if (typeof currentValue === 'object' && currentValue !== null && startValue !== null) {
			const currentKeys = Object.keys(currentValue);
			const startKeys = Object.keys(startValue);

			if (currentKeys.length !== startKeys.length) {
				console.log('Objects have different numbers of keys:', { currentKeys, startKeys });
				return true;
			}

			const keyDifference = currentKeys.some((key) => {
				const isDifferent = this.checkIfValueIsDifferent(currentValue[key], startValue[key]);
				if (isDifferent) {
					console.log('Objects have different values for key:', {
						key,
						currentValue: currentValue[key],
						startValue: startValue[key],
					});
				}
				return isDifferent;
			});
			return keyDifference;
		}

		// Primitive comparison
		const primitiveDifference = currentValue !== startValue;
		if (primitiveDifference) {
			console.log('Primitive values are different:', { currentValue, startValue });
		}
		return primitiveDifference;
	}

	// private checkIfValueIsDifferent(currentValue: any, startValue: any): boolean {
	// 	if (typeof currentValue !== typeof startValue) return true;

	// 	// Deep comparison for arrays
	// 	if (Array.isArray(currentValue) && Array.isArray(startValue)) {
	// 		if (currentValue.length !== startValue.length) return true;
	// 		return !currentValue.every((val, index) => val === startValue[index]);
	// 	}

	// 	// Deep comparison for objects
	// 	if (typeof currentValue === 'object' && currentValue !== null && startValue !== null) {
	// 		const currentKeys = Object.keys(currentValue);
	// 		const startKeys = Object.keys(startValue);
	// 		if (currentKeys.length !== startKeys.length) return true;

	// 		return currentKeys.some((key) => !this.checkIfValueIsDifferent(currentValue[key], startValue[key]));
	// 	}

	// 	// Primitive comparison
	// 	return currentValue !== startValue;
	// }

	// public setFilter(key: string, newValue: any) {
	// 	const updateFilterBar = (filterBar: any[]) => {
	// 		const item = filterBar.find((f) => f.key === key);
	// 		if (item) {
	// 			item.model = newValue;
	// 			item.isSet = this.checkIfValueIsSet(newValue);
	// 		}
	// 	};

	// 	updateFilterBar(this.displayBar);
	// 	updateFilterBar(this.displayBarHorses);
	// 	updateFilterBar(this.displayBarTack);

	// 	this.filterSubject.next(this.getFilterBar());
	// }

	// private checkIfValueIsSet(value: any): boolean {
	// 	if (value === null || value === undefined) return false;
	// 	if (Array.isArray(value)) return value.length > 0;
	// 	if (typeof value === 'object') {
	// 		return Object.keys(value).length > 0 && Object.values(value).some((v) => v !== '' && v !== 0);
	// 	}
	// 	return value !== '';
	// }

	public unsetFilter(key: string) {
		const unsetInFilterBar = (filterBar: any[]) => {
			const item = filterBar.find((f) => f.key === key);
			console.log('unsetFilter:');
			console.log(item);
			if (item) {
				item.model = item.start_value ? JSON.parse(JSON.stringify(item.start_value)) : null;
				item.isSet = false;
			}
		};

		unsetInFilterBar(this.displayBar);
		unsetInFilterBar(this.displayBarHorses);
		unsetInFilterBar(this.displayBarTack);

		this.filterSubject.next(this.getFilterBar());
	}

	// prepareAlgoliaFilters() {
	// 	const displayBar = this.getFilterBar();
	// 	const displayBarSet = displayBar.filter((item) => item.isSet);

	// 	console.log('displayBarSet:');
	// 	console.log(displayBarSet);

	// 	const groupBy = (array, key) =>
	// 		array.reduce((result, currentValue) => {
	// 			(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
	// 			return result;
	// 		}, {});

	// 	const groupedItems = groupBy(
	// 		displayBarSet.filter((item) => item.key !== 'topCat'),
	// 		'key'
	// 	);

	// 	const filterStrings = Object.keys(groupedItems)
	// 		.map((key) => {
	// 			const items = groupedItems[key];

	// 			const values = items.flatMap((item) => {
	// 				if (Array.isArray(item.model)) {
	// 					return item.model.map((val) => `${key}:${val.pk}`);
	// 				} else if (typeof item.model !== 'undefined' && typeof item.model.pk !== 'undefined') {
	// 					return `${key}:${item.model.pk}`;
	// 				}
	// 				return [];
	// 			});

	// 			return values.length > 0 ? values.join(' OR ') : '';
	// 		})
	// 		.filter(Boolean);

	// 	console.log('filterStrings:');
	// 	console.log(filterStrings);

	// 	return filterStrings.join(' AND ');
	// }

	// prepareAlgoliaFilters(): string {
	// 	const displayBar = this.getFilterBar();
	// 	const displayBarSet = displayBar.filter((item) => item.isSet); // Only include active filters

	// 	console.log('Active Filters (isSet = true):', displayBarSet);

	// 	// Group filters by key, excluding 'topCat'
	// 	const groupBy = (array: any[], key: string) =>
	// 		array.reduce((result, currentValue) => {
	// 			(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
	// 			return result;
	// 		}, {});

	// 	const groupedItems = groupBy(
	// 		displayBarSet.filter((item) => item.key !== 'topCat'), // Exclude 'topCat' from processing
	// 		'key'
	// 	);

	// 	// Construct filter strings
	// 	const filterStrings = Object.keys(groupedItems)
	// 		.map((key) => {
	// 			const items = groupedItems[key];

	// 			const values = items.flatMap((item) => {
	// 				if (Array.isArray(item.model)) {
	// 					// Handle array-based models
	// 					return item.model.map((val) => `${key}:${val.pk}`);
	// 				} else if (item.type === 'range' && item.model.lower !== undefined && item.model.upper !== undefined) {
	// 					// Handle range filters
	// 					return `${key} >= ${item.model.lower} AND ${key} <= ${item.model.upper}`;
	// 				} else if (item.model && typeof item.model.pk !== 'undefined') {
	// 					// Handle object-based models with 'pk' properties
	// 					return `${key}:${item.model.pk}`;
	// 				}
	// 				return [];
	// 			});

	// 			return values.length > 0 ? values.join(' OR ') : '';
	// 		})
	// 		.filter(Boolean); // Remove empty strings

	// 	console.log('Generated Filter Strings:', filterStrings);

	// 	// Combine filter strings with 'AND'
	// 	return filterStrings.join(' AND ');
	// }

	// prepareAlgoliaFilters(): string {
	// 	const displayBar = this.getFilterBar();

	// 	// Only include filters that are active (isSet = true)
	// 	const displayBarSet = displayBar.filter((item) => item.isSet);

	// 	console.log('Active Filters (isSet = true):', displayBarSet);

	// 	// Group filters by their key, excluding 'topCat' and 'location'
	// 	const groupBy = (array: any[], key: string) =>
	// 		array.reduce((result, currentValue) => {
	// 			(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
	// 			return result;
	// 		}, {});

	// 	const groupedItems = groupBy(
	// 		displayBarSet.filter((item) => item.key !== 'topCat' && item.key !== 'location'),
	// 		'key'
	// 	);

	// 	// Build filter strings for Algolia
	// 	const filterStrings = Object.keys(groupedItems)
	// 		.map((key) => {
	// 			const items = groupedItems[key];

	// 			// Build filter values for each group
	// 			const values = items.flatMap((item) => {
	// 				if (Array.isArray(item.model)) {
	// 					// Handle array-based models
	// 					return item.model.map((val) => `${key}:${val.pk}`);
	// 				} else if (item.type === 'range' && item.model.lower !== undefined && item.model.upper !== undefined) {
	// 					// Handle range filters
	// 					return `${key} >= ${item.model.lower} AND ${key} <= ${item.model.upper}`;
	// 				} else if (item.model && typeof item.model.pk !== 'undefined') {
	// 					// Handle object-based models with 'pk' properties
	// 					return `${key}:${item.model.pk}`;
	// 				}
	// 				return [];
	// 			});

	// 			return values.length > 0 ? values.join(' OR ') : ''; // Join multiple values with 'OR'
	// 		})
	// 		.filter(Boolean); // Remove empty strings

	// 	console.log('Generated Filter Strings:', filterStrings);

	// 	// Combine all filters with 'AND'
	// 	return filterStrings.join(' AND ');
	// }

	// prepareAlgoliaFilters(): string {
	// 	const displayBar = this.getFilterBar();
	// 	const displayBarSet = displayBar.filter((item) => item.isSet);
	// 	console.log('Active Filters (isSet = true):', JSON.stringify(displayBarSet, null, 2));
	// 	const groupBy = (array: any[], key: string) =>
	// 		array.reduce((result, currentValue) => {
	// 			(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
	// 			return result;
	// 		}, {});
	// 	const groupedItems = groupBy(
	// 		displayBarSet.filter((item) => item.key !== 'topCat' && item.key !== 'location'),
	// 		'key'
	// 	);
	// 	console.log('Grouped Filters:', JSON.stringify(groupedItems, null, 2));
	// 	const filterStrings = Object.keys(groupedItems)
	// 		.map((key) => {
	// 			const items = groupedItems[key];
	// 			const values = items.flatMap((item) => {
	// 				if (Array.isArray(item.model)) {
	// 					return item.model.map((val) => `${item.al_key}:${val.pk}`);
	// 				} else if (item.type === 'range' && item.model.lower !== undefined && item.model.upper !== undefined) {
	// 					return `${item.al_key} >= ${item.model.lower} AND ${item.al_key} <= ${item.model.upper}`;
	// 				} else if (item.model && typeof item.model.pk !== 'undefined') {
	// 					return `${item.al_key}:${item.model.pk}`;
	// 				}
	// 				return [];
	// 			});
	// 			return values.length > 0 ? values.join(' OR ') : '';
	// 		})
	// 		.filter(Boolean);
	// 	console.log('Final Filter Strings:', JSON.stringify(filterStrings, null, 2));
	// 	return filterStrings.join(' AND ');
	// }

	// prepareAlgoliaFilters(): any {
	// 	const displayBar = this.getFilterBar();
	// 	const displayBarSet = displayBar.filter((item) => item.isSet);

	// 	console.log('Active Filters (isSet = true):', JSON.stringify(displayBarSet, null, 2));

	// 	// Collect only the active facets
	// 	const facets = displayBarSet.map((item) => item.al_key).filter((key) => key !== undefined && key !== '');

	// 	console.log('Active Facets:', JSON.stringify(facets, null, 2));

	// 	// Group items by key for better handling
	// 	const groupBy = (array: any[], key: string) =>
	// 		array.reduce((result, currentValue) => {
	// 			(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
	// 			return result;
	// 		}, {});

	// 	const groupedItems = groupBy(
	// 		displayBarSet.filter((item) => item.key !== 'topCat'), // Exclude 'topCat' from processing
	// 		'key'
	// 	);

	// 	console.log('Grouped Filters:', JSON.stringify(groupedItems, null, 2));

	// 	const filterStrings = Object.keys(groupedItems)
	// 		.map((key) => {
	// 			const items = groupedItems[key];
	// 			const values = items.flatMap((item) => {
	// 				if (item.type === 'range' && item.model.lower !== undefined && item.model.upper !== undefined) {
	// 					return `${item.al_key} >= ${item.model.lower} AND ${item.al_key} <= ${item.model.upper}`;
	// 				} else if (Array.isArray(item.model)) {
	// 					return item.model.map((val) => `${item.al_key}:${val.pk}`);
	// 				} else if (item.model && typeof item.model.pk !== 'undefined') {
	// 					return `${item.al_key}:${item.model.pk}`;
	// 				}
	// 				return [];
	// 			});
	// 			return values.length > 0 ? values.join(' OR ') : '';
	// 		})
	// 		.filter(Boolean);

	// 	console.log('Generated Filter Strings:', JSON.stringify(filterStrings, null, 2));

	// 	const filterString = filterStrings.join(' AND ');

	// 	const finalObject = {
	// 		facets: facets.length > 0 ? facets : ['*'], // Include '*' if no facets are set, else use active facets
	// 		facetFilters: [], // This remains empty unless categorical filters are active
	// 		hitsPerPage: 10,
	// 		page: 0,
	// 		filters: filterString,
	// 	};

	// 	console.log('Final Prepared Object for Algolia:', JSON.stringify(finalObject, null, 2));

	// 	return finalObject;
	// }

	// prepareAlgoliaFilters(): any {
	// 	const displayBar = this.getFilterBar();
	// 	const displayBarSet = displayBar.filter((item) => item.isSet);

	// 	console.log('Active Filters (isSet = true):', JSON.stringify(displayBarSet, null, 2));

	// 	// Collect only the active facets
	// 	const facets = displayBarSet.map((item) => item.al_key).filter((key) => key !== undefined && key !== '');

	// 	console.log('Active Facets:', JSON.stringify(facets, null, 2));

	// 	// Group items by key for better handling
	// 	const groupBy = (array: any[], key: string) =>
	// 		array.reduce((result, currentValue) => {
	// 			(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
	// 			return result;
	// 		}, {});

	// 	const groupedItems = groupBy(
	// 		displayBarSet.filter((item) => item.key !== 'topCat'), // Exclude 'topCat' from processing
	// 		'key'
	// 	);

	// 	console.log('Grouped Filters:', JSON.stringify(groupedItems, null, 2));

	// 	const filterStrings = Object.keys(groupedItems)
	// 		.map((key) => {
	// 			const items = groupedItems[key];
	// 			const values = items.flatMap((item) => {
	// 				if (item.type === 'range' && item.model.lower !== undefined && item.model.upper !== undefined) {
	// 					// For temperament with itemList, use the value property
	// 					if (item.key === 'temperament' && item.itemList) {
	// 						const lowerValue = item.itemList[item.model.lower]?.value;
	// 						const upperValue = item.itemList[item.model.upper]?.value;

	// 						// If lower equals upper, do exact match instead of range
	// 						if (lowerValue === upperValue) {
	// 							return `${item.al_key} = ${lowerValue}`;
	// 						}
	// 						return `${item.al_key} >= ${lowerValue} AND ${item.al_key} <= ${upperValue}`;
	// 					}

	// 					// For height with itemList
	// 					if (item.key === 'height' && item.itemList) {
	// 						const lowerValue = item.itemList[item.model.lower]?.value;
	// 						const upperValue = item.itemList[item.model.upper]?.value;

	// 						// If lower equals upper, do exact match instead of range
	// 						if (lowerValue === upperValue) {
	// 							return `${item.al_key} = ${lowerValue}`;
	// 						}
	// 						return `${item.al_key} >= ${lowerValue} AND ${item.al_key} <= ${upperValue}`;
	// 					}

	// 					// For other range types like price
	// 					if (item.model.lower === item.model.upper) {
	// 						return `${item.al_key} = ${item.model.lower}`;
	// 					}
	// 					return `${item.al_key} >= ${item.model.lower} AND ${item.al_key} <= ${item.model.upper}`;
	// 				} else if (Array.isArray(item.model)) {
	// 					return item.model.map((val) => `${item.al_key}:${val.pk}`);
	// 				} else if (item.model && typeof item.model.pk !== 'undefined') {
	// 					return `${item.al_key}:${item.model.pk}`;
	// 				}
	// 				return [];
	// 			});
	// 			return values.length > 0 ? values.join(' OR ') : '';
	// 		})
	// 		.filter(Boolean);

	// 	console.log('Generated Filter Strings:', JSON.stringify(filterStrings, null, 2));

	// 	const filterString = filterStrings.join(' AND ');

	// 	const finalObject = {
	// 		facets: facets.length > 0 ? facets : ['*'], // Include '*' if no facets are set, else use active facets
	// 		facetFilters: [], // This remains empty unless categorical filters are active
	// 		hitsPerPage: 10,
	// 		page: 0,
	// 		filters: filterString,
	// 	};

	// 	console.log('Final Prepared Object for Algolia:', JSON.stringify(finalObject, null, 2));

	// 	return finalObject;
	// }

	// prepareAlgoliaFilters(): any {
	// 	const displayBar = this.getFilterBar();
	// 	const displayBarSet = displayBar.filter((item) => item.isSet);

	// 	console.log('Active Filters (isSet = true):', JSON.stringify(displayBarSet, null, 2));

	// 	// Collect only the active facets
	// 	const facets = displayBarSet
	// 		.map((item) => item.al_key)
	// 		.filter((key) => key !== undefined && key !== '');

	// 	console.log('Active Facets:', JSON.stringify(facets, null, 2));

	// 	// Group items by key for better handling
	// 	const groupBy = (array: any[], key: string) =>
	// 		array.reduce((result, currentValue) => {
	// 			(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
	// 			return result;
	// 		}, {});

	// 	const groupedItems = groupBy(
	// 		displayBarSet.filter((item) => item.key !== 'topCat'),
	// 		'key'
	// 	);

	// 	console.log('Grouped Filters:', JSON.stringify(groupedItems, null, 2));

	// 	const filterStrings = Object.keys(groupedItems)
	// 		.map((key) => {
	// 			const items = groupedItems[key];
	// 			const values = items.flatMap((item) => {
	// 				if (item.type === 'range' && item.model.lower !== undefined && item.model.upper !== undefined) {
	// 					// Handle range filters with itemLists (height, temperament, yearFoaled)
	// 					if (['height', 'temperament', 'yearFoaled'].includes(item.key) && item.itemList) {
	// 						let lowerValue, upperValue;

	// 						if (item.key === 'yearFoaled') {
	// 							// For yearFoaled, use the direct values since they're already year numbers
	// 							lowerValue = item.model.lower;
	// 							upperValue = item.model.upper;
	// 						} else {
	// 							// For height and temperament, get values from itemList
	// 							lowerValue = item.itemList[item.model.lower]?.value;
	// 							upperValue = item.itemList[item.model.upper]?.value;
	// 						}

	// 						if (lowerValue === upperValue) {
	// 							return `${item.al_key} = ${lowerValue}`;
	// 						}
	// 						return `${item.al_key} >= ${lowerValue} AND ${item.al_key} <= ${upperValue}`;
	// 					}

	// 					// For other range types like price
	// 					if (item.model.lower === item.model.upper) {
	// 						return `${item.al_key} = ${item.model.lower}`;
	// 					}
	// 					return `${item.al_key} >= ${item.model.lower} AND ${item.al_key} <= ${item.model.upper}`;
	// 				} else if (Array.isArray(item.model)) {
	// 					return item.model.map((val) => `${item.al_key}:${val.pk}`);
	// 				} else if (item.model && typeof item.model.pk !== 'undefined') {
	// 					return `${item.al_key}:${item.model.pk}`;
	// 				}
	// 				return [];
	// 			});
	// 			return values.length > 0 ? values.join(' OR ') : '';
	// 		})
	// 		.filter(Boolean);

	// 	console.log('Generated Filter Strings:', JSON.stringify(filterStrings, null, 2));

	// 	const filterString = filterStrings.join(' AND ');

	// 	const finalObject = {
	// 		facets: facets.length > 0 ? facets : ['*'],
	// 		facetFilters: [],
	// 		hitsPerPage: 10,
	// 		page: 0,
	// 		filters: filterString,
	// 	};

	// 	console.log('Final Prepared Object for Algolia:', JSON.stringify(finalObject, null, 2));

	// 	return finalObject;
	// }

	/**
	 * Apply a saved search's filters to the current filter state
	 * Handles both new format and legacy parsed format
	 */
	applySavedSearch(filters: { [key: string]: any }, notifySubscribers = true): void {
		console.log('Applying saved search filters:', filters);

		// Reset all filters first
		this.displayBar.forEach((filter) => {
			if (filter.start_value !== undefined) {
				filter.model = this.cloneFilterValue(filter.start_value);
				filter.isSet = false;
			}
		});
		this.displayBarHorses.forEach((filter) => {
			if (filter.start_value !== undefined) {
				filter.model = this.cloneFilterValue(filter.start_value);
				filter.isSet = false;
			}
		});
		this.displayBarTack.forEach((filter) => {
			if (filter.start_value !== undefined) {
				filter.model = this.cloneFilterValue(filter.start_value);
				filter.isSet = false;
			}
		});

		// Apply saved filters with proper mapping
		Object.keys(filters).forEach((key) => {
			const value = filters[key];
			if (value === null || value === undefined) return;

			// Map legacy keys to current keys and convert values
			const mappedValue = this.mapSavedFilterValue(key, value);
			if (mappedValue !== null) {
				this.setFilterInternal(key, mappedValue);
			}
		});

		if (notifySubscribers) {
			this.notifySubscribers();
		}
	}

	/**
	 * Map saved filter values to current filter model format
	 * Handles legacy format (arrays of PKs) and converts to proper filter objects
	 */
	private mapSavedFilterValue(key: string, value: any): any {
		// Handle array filters (breed, color, gender, skills, saleTypes)
		if (Array.isArray(value)) {
			const filterDef = this.findFilterDefinition(key);
			if (filterDef && filterDef.itemList) {
				// Map PKs to full objects from itemList
				const mappedItems = value
					.map((pk) => filterDef.itemList.find((item: any) => item.pk === pk))
					.filter((item) => item !== undefined);
				return mappedItems.length > 0 ? mappedItems : null;
			}
			return value;
		}

		// Handle range filters (askingPrice, leasePrice)
		if (value && typeof value === 'object' && ('lower' in value || 'upper' in value)) {
			const filterDef = this.findFilterDefinition(key);
			if (filterDef) {
				return {
					lower: value.lower ?? filterDef.min ?? 0,
					upper: value.upper ?? filterDef.max ?? filterDef.start_value?.upper,
				};
			}
			return value;
		}

		// Handle location filter
		if (key === 'location' && typeof value === 'object') {
			// Check if location has any meaningful data
			const hasData = value.lat || value.long || value.city || value.state || value.address;
			if (!hasData && (!value.range || value.range === 0)) {
				return null; // Skip empty location
			}
			return {
				address: value.address || '',
				address_2: value.address_2 || '',
				city: value.city || '',
				state: value.state || '',
				country: value.country || '',
				postal: value.postal || '',
				lat: value.lat || '',
				long: value.long || '',
				range: value.range || 0,
				placeName: value.placeName || '',
			};
		}

		return value;
	}

	/**
	 * Find a filter definition by key across all filter bars
	 */
	private findFilterDefinition(key: string): any {
		return (
			this.displayBar.find((f) => f.key === key) ||
			this.displayBarHorses.find((f) => f.key === key) ||
			this.displayBarTack.find((f) => f.key === key)
		);
	}

	/**
	 * Internal setFilter that doesn't notify subscribers (for batch operations)
	 */
	private setFilterInternal(key: string, newValue: any): void {
		this.updateFilterBar(key, (filter) => {
			filter.model = JSON.parse(JSON.stringify(newValue));
			filter.isSet = this.determineFilterIsSet(filter, newValue);
		});
	}

	/**
	 * Get current filter state for saving
	 */
	getCurrentFiltersForSave(): { [key: string]: any } {
		const filters: { [key: string]: any } = {};
		const allFilters = [...this.displayBar, ...this.displayBarHorses, ...this.displayBarTack];

		allFilters.forEach((filter) => {
			if (filter.isSet && filter.key !== 'topCat') {
				filters[filter.key] = this.cloneFilterValue(filter.model);
			}
		});

		return filters;
	}

	/**
	 * Get filter bar in stable order (not reordered by isSet)
	 * Used for filter panel where stable positioning is preferred
	 */
	getFilterBarStable(): any[] {
		return [...this.displayBar, ...this.displayBarHorses];
	}

	/**
	 * Create a snapshot of current filter state for comparison
	 */
	createFilterSnapshot(): { [key: string]: any } {
		const snapshot: { [key: string]: any } = {};
		const allFilters = [...this.displayBar, ...this.displayBarHorses, ...this.displayBarTack];

		allFilters.forEach((filter) => {
			snapshot[filter.key] = {
				model: this.cloneFilterValue(filter.model),
				isSet: filter.isSet,
			};
		});

		return snapshot;
	}

	/**
	 * Compare current filter state with a snapshot
	 * Returns true if filters have changed
	 */
	hasChangesFromSnapshot(snapshot: { [key: string]: any }): boolean {
		const allFilters = [...this.displayBar, ...this.displayBarHorses, ...this.displayBarTack];

		for (const filter of allFilters) {
			const snapshotEntry = snapshot[filter.key];
			if (!snapshotEntry) continue;

			// Compare isSet
			if (filter.isSet !== snapshotEntry.isSet) {
				return true;
			}

			// Deep compare model
			if (JSON.stringify(filter.model) !== JSON.stringify(snapshotEntry.model)) {
				return true;
			}
		}

		return false;
	}

	prepareAlgoliaFilters(): any {
		console.log('\n🔍 === ALGOLIA FILTER PREPARATION START ===');

		const displayBar = this.getFilterBar();
		console.log(
			'📊 All Filters:',
			displayBar.map((f) => ({ key: f.key, label: f.label, isSet: f.isSet, model: f.model, start_value: f.start_value }))
		);

		const displayBarSet = displayBar.filter((item) => item.isSet);
		console.log(
			'✅ Active Filters (isSet = true):',
			displayBarSet.map((f) => ({
				key: f.key,
				label: f.label,
				model: f.model,
				modelLength: Array.isArray(f.model) ? f.model.length : 'N/A',
				itemListLength: Array.isArray(f.itemList) ? f.itemList.length : 'N/A',
			}))
		);

		// Detect "all selected" cases
		displayBarSet.forEach((filter) => {
			if (Array.isArray(filter.model) && Array.isArray(filter.itemList)) {
				const isAllSelected = filter.model.length === filter.itemList.length;
				if (isAllSelected) {
					console.log(
						`⚠️  Filter "${filter.key}" has ALL items selected (${filter.model.length}/${filter.itemList.length}) - this might cause empty Algolia results!`
					);
				}
			}
		});

		// Collect only the active facets
		const facets = displayBarSet.map((item) => item.al_key).filter((key) => key !== undefined && key !== '');
		console.log('🏷️  Active Facets for Algolia:', facets);

		// Group items by key for better handling
		const groupBy = (array: any[], key: string) =>
			array.reduce((result, currentValue) => {
				(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
				return result;
			}, {});

		const groupedItems = groupBy(
			displayBarSet.filter((item) => item.key !== 'topCat'),
			'key'
		);

		console.log(
			'🗂️  Grouped Filters (excluding topCat):',
			Object.keys(groupedItems).map((key) => ({
				key,
				filters: groupedItems[key].map((f) => ({ label: f.label, al_key: f.al_key, model: f.model })),
			}))
		);

		const filterStrings = Object.keys(groupedItems)
			.map((key) => {
				const items = groupedItems[key];
				console.log(
					`🔧 Processing filter group "${key}":`,
					items.map((i) => ({ type: i.type, al_key: i.al_key, model: i.model }))
				);

				const values = items.flatMap((item) => {
					let filterValue;

					if (item.type === 'range' && item.model.lower !== undefined && item.model.upper !== undefined) {
						if (['height', 'temperament', 'yearFoaled'].includes(item.key) && item.itemList) {
							const lowerIndex = Math.min(Math.max(0, item.model.lower), item.itemList.length - 1);
							const upperIndex = Math.min(Math.max(0, item.model.upper), item.itemList.length - 1);
							const lowerValue = item.itemList[lowerIndex]?.value;
							const upperValue = item.itemList[upperIndex]?.value;

							if (lowerValue === upperValue) {
								filterValue = `${item.al_key} = ${lowerValue}`;
							} else {
								filterValue = `${item.al_key} >= ${lowerValue} AND ${item.al_key} <= ${upperValue}`;
							}
						} else {
							// For other range types like price
							if (item.model.lower === item.model.upper) {
								filterValue = `${item.al_key} = ${item.model.lower}`;
							} else {
								filterValue = `${item.al_key} >= ${item.model.lower} AND ${item.al_key} <= ${item.model.upper}`;
							}
						}
						console.log(`  📏 Range filter generated: "${filterValue}"`);
						return filterValue;
					} else if (Array.isArray(item.model)) {
						// Check if all items are selected
						const isAllSelected = item.itemList && item.model.length === item.itemList.length;
						if (isAllSelected) {
							console.log(`  ⚠️  Skipping "${item.key}" - all items selected (${item.model.length}/${item.itemList.length})`);
							return []; // Skip this filter to avoid over-filtering
						}

						const arrayFilters = item.model.map((val) => `${item.al_key}:${val.pk}`);
						console.log(`  📋 Array filter generated: [${arrayFilters.join(', ')}]`);
						return arrayFilters;
					} else if (item.model && typeof item.model.pk !== 'undefined') {
						filterValue = `${item.al_key}:${item.model.pk}`;
						console.log(`  🎯 Single filter generated: "${filterValue}"`);
						return filterValue;
					}

					console.log(`  ❓ No filter generated for ${item.key} (type: ${item.type})`);
					return [];
				});

				const joinedValues = values.length > 0 ? values.join(' OR ') : '';
				console.log(`  ➡️  Final filter string for "${key}": "${joinedValues}"`);
				return joinedValues;
			})
			.filter(Boolean);

		console.log('🎛️  Generated Filter Strings:', filterStrings);

		const filterString = filterStrings.join(' AND ');
		console.log('🔗 Combined Filter String:', `"${filterString}"`);

		const finalObject = {
			facets: facets.length > 0 ? facets : ['*'],
			facetFilters: [],
			hitsPerPage: 10,
			page: 0,
			filters: filterString,
			attributesToRetrieve: ['*', 'modified'], // Ensure modified is retrieved
		};

		console.log('🚀 Final Algolia Request Object:', JSON.stringify(finalObject, null, 2));
		console.log('🔍 === ALGOLIA FILTER PREPARATION END ===\n');

		return finalObject;
	}
}
